import { render, staticRenderFns } from "./upsell.vue?vue&type=template&id=0dd29e85"
import script from "./upsell.vue?vue&type=script&lang=js"
export * from "./upsell.vue?vue&type=script&lang=js"
import style0 from "./upsell.vue?vue&type=style&index=0&id=0dd29e85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports